// AdminPage.js
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  getAdminAllWeddings,
  updateWeddingQuota,
  createWeddingByAdmin,
  updateWeddingTheme,
  updateWeddingAlbums,
  setUploadsLocked,
  deleteWeddingByAdmin,
  getAdminAllCoupons,
  createCouponByAdmin,
  deleteCouponByAdmin,
  toggleCouponByAdmin,
  updateWeddingOwnerEmail,
  updateWeddingName,
} from '../services/apiService';
import '../styles/adminpage.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getAdminAllBlogs, createBlogPost, deleteBlogPost, getAdminWeddingLogs } from '../services/apiService';
import { QRCodeSVG } from 'qrcode.react';

import AdminOrganizationsTab from './AdminOrganizationsTab';
import AdminOrdersTab from './AdminOrdersTab';
import AdminLogsTab from './AdminLogsTab';

// Byte'ları okunabilir formata çevir
function formatBytes(bytes, decimals = 2) {
  if (!bytes || bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export default function AdminPage() {
  const [weddings, setWeddings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [activeTab, setActiveTab] = useState('weddings'); // 'weddings' | 'organizations' | 'orders'

  // Tema düzenleme
  const [editingThemeId, setEditingThemeId] = useState(null);
  const [newTheme, setNewTheme] = useState('');

  const [editingAlbumsId, setEditingAlbumsId] = useState(null);
  const [newAlbums, setNewAlbums] = useState([]);

  // Kota düzenleme
  const [editingQuotaId, setEditingQuotaId] = useState(null);
  const [newQuota, setNewQuota] = useState('');

  // E-posta düzenleme
  const [editingEmailId, setEditingEmailId] = useState(null);
  const [newEmail, setNewEmail] = useState('');

  // İsim düzenleme
  const [editingNameId, setEditingNameId] = useState(null);
  const [newName, setNewName] = useState('');

  // Yeni düğün modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isBlogModalOpen, setIsBlogModalOpen] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [newBlogData, setNewBlogData] = useState({
    title: '',
    content: '',
    coverImage: ''
  });

  // Log Modal
  const [isLogsModalOpen, setIsLogsModalOpen] = useState(false);
  const [logsWedding, setLogsWedding] = useState(null);
  const [weddingLogs, setWeddingLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);

  // --- KUPON MODALI STEYTLERİ ---
  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [newCouponData, setNewCouponData] = useState({
    code: '',
    discountType: 'percentage',
    discountValue: '',
    expirationDate: ''
  });

  const fetchCoupons = useCallback(async () => {
    try {
      const data = await getAdminAllCoupons();
      setCoupons(data);
    } catch (err) {
      console.error("Kuponlar yüklenemedi:", err.message);
    }
  }, []);

  const handleCouponSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
        await createCouponByAdmin(newCouponData);
        alert('Kupon başarıyla eklendi!');
        setNewCouponData({ code: '', discountType: 'percentage', discountValue: '', expirationDate: '' });
        fetchCoupons();
    } catch (err) {
        alert(`Hata: ${err.message}`);
    } finally {
        setIsSubmitting(false);
    }
  };

  const handleToggleCoupon = async (id) => {
    try {
        await toggleCouponByAdmin(id);
        fetchCoupons();
    } catch (err) {
        alert(`Hata: ${err.message}`);
    }
  };

  const handleDeleteCoupon = async (id, code) => {
    if (window.confirm(`${code} kuponunu silmek istediğinize emin misiniz?`)) {
        try {
            await deleteCouponByAdmin(id);
            fetchCoupons();
        } catch (err) {
            alert(`Hata: ${err.message}`);
        }
    }
  };

  // Blogları listeleme fonksiyonu
  const fetchBlogs = useCallback(async () => {
    try {
      const data = await getAdminAllBlogs();
      setBlogs(data);
    } catch (err) {
      console.error("Bloglar yüklenemedi:", err.message);
    }
  }, []);

  const handleBlogSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await createBlogPost(newBlogData);
      alert('Blog yazısı başarıyla eklendi!');
      setIsBlogModalOpen(false);
      setNewBlogData({ title: '', content: '', coverImage: '' });
      fetchBlogs();
    } catch (err) {
      alert(`Hata: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ GÜNCELLEME 1: albumMode eklendi
  const [newWeddingData, setNewWeddingData] = useState({
    name: '',
    date: '',
    ownerEmail: '',
    theme: 'default',
    albumMode: 'default' // Varsayılan paket
  });

  const [creationResult, setCreationResult] = useState(null);

  const fetchWeddings = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const data = await getAdminAllWeddings();
      setWeddings(data);
    } catch (err) {
      setError(
        err.message ||
        'Düğün listesi alınamadı. Lütfen admin olarak giriş yaptığınızdan emin olun.'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWeddings();
  }, [fetchWeddings]);

  // ✅ YENİ: Düğün silme işlemini yönetecek fonksiyon
  const handleDeleteWedding = async (weddingId, weddingName) => {
    // Kullanıcıya kritik bir onay sorusu soruyoruz
    const confirmation = window.confirm(
      `'${weddingName}' adlı düğünü ve tüm içeriğini KALICI OLARAK silmek istediğinize emin misiniz?\n\nBU İŞLEM GERİ ALINAMAZ!`
    );

    if (confirmation) {
      try {
        const result = await deleteWeddingByAdmin(weddingId);
        alert(result.message); // Başarı mesajını göster
        fetchWeddings(); // Silme sonrası tabloyu yenile
      } catch (err) {
        alert(`Hata: ${err.message}`); // Hata mesajını göster
      }
    }
  };

  // Kota düzenleme
  const handleEditQuotaClick = (wedding) => {
    setEditingQuotaId(wedding._id);
    setNewQuota(wedding.storageQuotaGB);
    setEditingThemeId(null);
  };

  // Tema düzenleme
  const handleEditThemeClick = (wedding) => {
    setEditingThemeId(wedding._id);
    setNewTheme(wedding.theme || 'default');
    setEditingQuotaId(null);
  };

  const handleCancelClick = () => {
    setEditingQuotaId(null);
    setEditingThemeId(null);
    setEditingAlbumsId(null);
    setEditingEmailId(null);
    setEditingNameId(null);
    setNewQuota('');
    setNewTheme('');
    setNewAlbums([]);
    setNewEmail('');
    setNewName('');
  };

  const handleEditNameClick = (wedding) => {
    setEditingNameId(wedding._id);
    setNewName(wedding.name || '');
    setEditingQuotaId(null);
    setEditingThemeId(null);
    setEditingAlbumsId(null);
    setEditingEmailId(null);
  };

  const handleSaveName = async (weddingId) => {
    const trimmed = newName.trim();
    if (!trimmed) {
      alert('Lütfen geçerli bir düğün adı/çift ismi girin.');
      return;
    }
    try {
      await updateWeddingName(weddingId, trimmed);
      alert('Düğün çift ismi başarıyla güncellendi!');
      setEditingNameId(null);
      setNewName('');
      fetchWeddings();
    } catch (err) {
      alert(`İsim güncelleme başarısız: ${err.message}`);
    }
  };

  const handleEditEmailClick = (wedding) => {
    setEditingEmailId(wedding._id);
    setNewEmail(wedding.ownerEmail || '');
    setEditingQuotaId(null);
    setEditingThemeId(null);
    setEditingAlbumsId(null);
  };

  const handleSaveEmail = async (weddingId) => {
    const trimmed = newEmail.trim().toLowerCase();
    if (!trimmed || !trimmed.includes('@') || !trimmed.includes('.')) {
      alert('Lütfen geçerli bir e-posta adresi girin.');
      return;
    }
    try {
      const res = await updateWeddingOwnerEmail(weddingId, trimmed);
      if (res.temporaryPassword) {
        alert(`${res.message}\n\nYeni sahip kullanıcısı geçici şifresi: ${res.temporaryPassword}`);
      } else {
        alert(res.message);
      }
      setEditingEmailId(null);
      setNewEmail('');
      fetchWeddings();
    } catch (err) {
      alert(`E-posta güncelleme başarısız: ${err.message}`);
    }
  };

  const handleEditAlbumsClick = (wedding) => {
    setEditingAlbumsId(wedding._id);
    setNewAlbums([...(wedding.albumNames || [])]);
    setEditingQuotaId(null);
    setEditingThemeId(null);
  };

  const handleSaveAlbums = async (weddingId) => {
    try {
      await updateWeddingAlbums(weddingId, newAlbums);
      alert('Albümler başarıyla güncellendi!');
      setEditingAlbumsId(null);
      fetchWeddings();
    } catch (err) {
      alert(`Albüm güncelleme başarısız: ${err.message}`);
    }
  };

  const handleAlbumNameChange = (index, value) => {
    const updated = [...newAlbums];
    updated[index] = value;
    setNewAlbums(updated);
  };

  const handleSaveQuota = async (weddingId) => {
    if (!newQuota || Number(newQuota) <= 0) {
      alert("Lütfen geçerli bir kota girin (0'dan büyük bir sayı).");
      return;
    }
    try {
      await updateWeddingQuota(weddingId, newQuota);
      alert('Kota başarıyla güncellendi!');
      setEditingQuotaId(null);
      fetchWeddings();
    } catch (err) {
      alert(`Güncelleme başarısız: ${err.message}`);
    }
  };

  const handleSaveTheme = async (weddingId) => {
    if (!newTheme) {
      alert('Lütfen bir tema seçin.');
      return;
    }
    try {
      await updateWeddingTheme(weddingId, newTheme);
      alert('Tema başarıyla güncellendi!');
      setEditingThemeId(null);
      fetchWeddings();
    } catch (err) {
      alert(`Tema güncelleme başarısız: ${err.message}`);
    }
  };

  // ✅ Yükleme açık/kapalı
  const handleToggleUploads = async (wedding) => {
    try {
      await setUploadsLocked(wedding._id, !wedding.uploadsLocked);
      fetchWeddings();
    } catch (err) {
      alert(`Yükleme durumu güncellenemedi: ${err.message}`);
    }
  };

  const handleViewLogs = async (wedding) => {
    setLogsWedding(wedding);
    setIsLogsModalOpen(true);
    setLoadingLogs(true);
    setWeddingLogs([]);
    try {
        const res = await getAdminWeddingLogs(wedding._id);
        setWeddingLogs(res.logs || []);
    } catch (err) {
        alert("Loglar getirilemedi: " + err.message);
    } finally {
        setLoadingLogs(false);
    }
  };

  // Yeni düğün inputları
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewWeddingData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateWedding = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const result = await createWeddingByAdmin(newWeddingData);
      setCreationResult(result);
      fetchWeddings();
    } catch (err) {
      alert(`Hata: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // ✅ GÜNCELLEME: Formu sıfırlarken albumMode'u da sıfırla
    setNewWeddingData({ name: '', date: '', ownerEmail: '', theme: 'default', albumMode: 'default' });
    setCreationResult(null);
  };

  const [nameQuery, setNameQuery] = useState('');
  const [viewingQrWedding, setViewingQrWedding] = useState(null);

  const visibleWeddings = useMemo(() => {
    const q = nameQuery.trim().toLocaleLowerCase('tr');
    if (!q) return weddings;
    return weddings.filter(w =>
      (w.name || '').toLocaleLowerCase('tr').includes(q)
    );
  }, [weddings, nameQuery]);


  if (loading && weddings.length === 0)
    return (
      <div className="admin-container">
        <p>Yükleniyor...</p>
      </div>
    );
  if (error)
    return (
      <div className="admin-container">
        <p style={{ color: 'red' }}>HATA: {error}</p>
      </div>
    );

  return (
    <div className="admin-container">
      <div className="admin-header" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <h1 style={{ flexGrow: 1 }}>Admin Paneli</h1>
        
        <div style={{ display: 'flex', gap: '5px' }}>
          <button 
            className={activeTab === 'weddings' ? 'btn' : 'btn-outline'} 
            onClick={() => setActiveTab('weddings')}
          >
            Düğünler
          </button>
          <button 
            className={activeTab === 'organizations' ? 'btn' : 'btn-outline'} 
            onClick={() => setActiveTab('organizations')}
          >
            Organizasyonlar
          </button>
          <button 
            className={activeTab === 'orders' ? 'btn' : 'btn-outline'} 
            onClick={() => setActiveTab('orders')}
          >
            Siparişler
          </button>
          <button 
            className={activeTab === 'logs' ? 'btn' : 'btn-outline'} 
            onClick={() => setActiveTab('logs')}
          >
            Sistem Günlükleri
          </button>
        </div>

        {activeTab === 'weddings' && (
          <button className="btn" style={{marginLeft: 20}} onClick={() => setIsModalOpen(true)}>
            + Yeni Düğün
          </button>
        )}
        
        <button className="btn-outline" onClick={() => { setIsCouponModalOpen(true); fetchCoupons(); }}>
          🎟️ Kuponlar
        </button>
      </div>

      {activeTab === 'organizations' && <AdminOrganizationsTab />}
      {activeTab === 'orders' && <AdminOrdersTab />}
      {activeTab === 'logs' && <AdminLogsTab />}

      {activeTab === 'weddings' && (
        <div className="table-scroll">
        <table className="admin-table">
          <thead>
            <tr>
              <th>
                <div className="th-with-filter">
                  <span>Düğün Adı</span>
                  <input
                    type="text"
                    className="th-search"
                    placeholder="Ara…"
                    value={nameQuery}
                    onChange={(e) => setNameQuery(e.target.value)}
                  />
                </div>
              </th>
              <th style={{ minWidth: 200 }}>Sahibi (Email)</th>

              {/* ✅ GÜNCELLEME 2: Paket Sütunu Eklendi */}
              <th style={{ minWidth: 120 }}>Paket</th>
              <th style={{ minWidth: 100 }}>Basılı Kart</th>

              <th style={{ minWidth: 180 }}>Kullanım / Kota</th>
              <th style={{ width: 120 }}>Fotoğraf</th>
              <th style={{ minWidth: 180 }}>Yüklemeler</th>
              <th style={{ minWidth: 260 }}>İşlemler</th>
            </tr>
          </thead>

          <tbody>
            {visibleWeddings.map((wedding) => (
              <tr key={wedding._id}>
                <td>
                  {editingNameId === wedding._id ? (
                    <div className="edit-inline" style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                      <input
                        type="text"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                        style={{ width: '150px', padding: '2px 5px', fontSize: '0.8rem' }}
                      />
                      <button className="btn btn-xs" onClick={() => handleSaveName(wedding._id)} style={{ padding: '2px 6px', fontSize: '0.75rem' }}>
                        Kaydet
                      </button>
                      <button className="btn-outline btn-xs" onClick={handleCancelClick} style={{ padding: '2px 6px', fontSize: '0.75rem' }}>
                        İptal
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <span style={{ marginRight: '5px' }}>{wedding.name}</span>
                      <button 
                        className="btn-outline btn-xs" 
                        onClick={() => handleEditNameClick(wedding)}
                        style={{ padding: '1px 5px', fontSize: '0.7rem', whiteSpace: 'nowrap' }}
                      >
                        Düzenle
                      </button>
                    </div>
                  )}
                </td>
                <td className="email-cell" title={wedding.ownerEmail}>
                  {editingEmailId === wedding._id ? (
                    <div className="edit-inline" style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                      <input
                        type="email"
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        style={{ width: '150px', padding: '2px 5px', fontSize: '0.8rem' }}
                      />
                      <button className="btn btn-xs" onClick={() => handleSaveEmail(wedding._id)} style={{ padding: '2px 6px', fontSize: '0.75rem' }}>
                        Kaydet
                      </button>
                      <button className="btn-outline btn-xs" onClick={handleCancelClick} style={{ padding: '2px 6px', fontSize: '0.75rem' }}>
                        İptal
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <span style={{ marginRight: '5px' }}>{wedding.ownerEmail || 'E-posta Yok'}</span>
                      <button 
                        className="btn-outline btn-xs" 
                        onClick={() => handleEditEmailClick(wedding)}
                        style={{ padding: '1px 5px', fontSize: '0.7rem', whiteSpace: 'nowrap' }}
                      >
                        Düzenle
                      </button>
                    </div>
                  )}
                </td>

                {/* ✅ GÜNCELLEME 3: Paket Durumunu Göster */}
                <td>
                  {wedding.albumMode === 'dual' ?
                    <span className="badge badge-warning">2 Albüm</span> :
                    wedding.albumMode === 'triple' ?
                      <span className="badge badge-success">3 Albüm</span> :
                      wedding.albumMode === 'demo' ?
                        <span className="badge badge-info" style={{ backgroundColor: '#17a2b8', color: 'white' }}>Demo (3 Albüm)</span> :
                      <span className="badge badge-secondary">Standart</span>
                  }
                </td>

                <td>
                  <div style={{ fontSize: '0.85rem' }}>
                    {wedding.tableCardCount > 0 && <div>Masa: {wedding.tableCardCount}</div>}
                    {wedding.handCardCount > 0 && <div>El: {wedding.handCardCount}</div>}
                    {(!wedding.tableCardCount && !wedding.handCardCount) && <span style={{color: '#999'}}>-</span>}
                  </div>
                </td>

                <td>
                  {wedding.storageQuotaGB > 10000 
                    ? `${formatBytes(wedding.currentUsageBytes)} / Sınırsız`
                    : `${formatBytes(wedding.currentUsageBytes)} / ${wedding.storageQuotaGB || 'N/A'} GB`
                  }
                </td>
                <td>{wedding.photoCount}</td>

                {/* ✅ Yüklemeler sütunu */}
                <td>
                  <div className="lock-cell">
                    <span
                      className={`badge ${wedding.uploadsLocked ? 'badge-locked' : 'badge-open'
                        }`}
                    >
                      {wedding.uploadsLocked ? 'Kapalı' : 'Açık'}
                    </span>
                    <button
                      className="btn-outline btn-xs"
                      onClick={() => handleToggleUploads(wedding)}
                      title={wedding.uploadsLocked ? 'Yüklemeleri aç' : 'Yüklemeleri kapat'}
                    >
                      {wedding.uploadsLocked ? 'Aç' : 'Kapat'}
                    </button>
                  </div>
                </td>

                {/* Kota & Tema işlemleri */}
                <td className="actions-cell">
                  {/* Kota */}
                  {editingQuotaId === wedding._id ? (
                    <div className="edit-inline">
                      <input
                        type="number"
                        min="1"
                        value={newQuota}
                        onChange={(e) => setNewQuota(e.target.value)}
                      />
                      <button className="btn btn-xs" onClick={() => handleSaveQuota(wedding._id)}>
                        Kaydet
                      </button>
                      <button className="btn-outline btn-xs" onClick={handleCancelClick}>
                        İptal
                      </button>
                    </div>
                  ) : (
                    <button
                      className="btn-outline btn-xs"
                      onClick={() => handleEditQuotaClick(wedding)}
                    >
                      Kota
                    </button>
                  )}

                  {/* Tema */}
                  {editingThemeId === wedding._id ? (
                    <div className="edit-inline">
                      <select value={newTheme} onChange={(e) => setNewTheme(e.target.value)}>
                        <option value="default">Pembe Tema</option>
                        <option value="lavender-dream">Lavanta Tema</option>
                        <option value="classic-grey">Klasik Gri</option>
                        <option value="modern-blue">Modern Mavi</option>
                        <option value="vibrant-mint">Nane Yeşili</option>
                      </select>
                      <button className="btn btn-xs" onClick={() => handleSaveTheme(wedding._id)}>
                        Kaydet
                      </button>
                      <button className="btn-outline btn-xs" onClick={handleCancelClick}>
                        İptal
                      </button>
                    </div>
                  ) : (
                    <button
                      className="btn-outline btn-xs"
                      onClick={() => handleEditThemeClick(wedding)}
                    >
                      Tema
                    </button>
                  )}

                  {/* Albümler */}
                  {editingAlbumsId === wedding._id ? (
                    <div className="edit-inline" style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '5px' }}>
                      {newAlbums.map((abm, idx) => (
                        <input
                          key={idx}
                          type="text"
                          value={abm}
                          onChange={(e) => handleAlbumNameChange(idx, e.target.value)}
                          style={{ width: '120px', padding: '2px 5px', fontSize: '0.8rem' }}
                        />
                      ))}
                      <div style={{ display: 'flex', gap: '5px' }}>
                        <button className="btn btn-xs" onClick={() => handleSaveAlbums(wedding._id)}>Kaydet</button>
                        <button className="btn-outline btn-xs" onClick={handleCancelClick}>İptal</button>
                      </div>
                    </div>
                  ) : (
                    <button
                      className="btn-outline btn-xs"
                      onClick={() => handleEditAlbumsClick(wedding)}
                      disabled={!wedding.albumNames || wedding.albumNames.length === 0}
                      title={(!wedding.albumNames || wedding.albumNames.length === 0) ? "Bu düğünde çoklu albüm yok" : "Albümleri Düzenle"}
                    >
                      Albümler
                    </button>
                  )}

                  {/* Karekod Butonu */}
                  <button
                    className="btn-outline btn-xs"
                    onClick={() => setViewingQrWedding(wedding)}
                    style={{ marginRight: '5px' }}
                  >
                    Karekod
                  </button>
                  {/* Log Butonu */}
                  <button
                    className="btn-outline btn-xs"
                    onClick={() => handleViewLogs(wedding)}
                    style={{ marginRight: '5px' }}
                  >
                    📜 Loglar
                  </button>
                  {/* Sil Butonu (artık koşulun dışında ve her zaman görünür) */}
                  <button
                    className="btn-danger btn-xs"
                    onClick={() => handleDeleteWedding(wedding._id, wedding.name)}
                  >
                    Sil
                  </button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}

      {/* Yeni düğün modalı */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button onClick={closeModal} className="modal-close-btn">
              &times;
            </button>

            {creationResult ? (
              <div>
                <h2>{creationResult.message}</h2>
                <div className="qr-code-container">
                  <img src={creationResult.qrDataUrl} alt="Düğün QR Kodu" />
                </div>
                <p>
                  <strong>Düğün Kodu:</strong> {creationResult.wedding.code}
                </p>
                <p>
                  <strong>Sahip E-postası:</strong> {creationResult.ownerEmail}
                </p>
                {creationResult.temporaryPassword && (
                  <p>
                    <strong>GEÇİCİ ŞİFRE:</strong>{' '}
                    <strong style={{ color: 'red' }}>{creationResult.temporaryPassword}</strong>
                  </p>
                )}
                <button className="btn" onClick={closeModal}>
                  Kapat
                </button>
              </div>
            ) : (
              <form onSubmit={handleCreateWedding}>
                <h2>Yeni Düğün Oluştur</h2>
                <input
                  type="text"
                  name="name"
                  placeholder="Çiftin Adı (örn: Selin & Ozan)"
                  value={newWeddingData.name}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="date"
                  name="date"
                  value={newWeddingData.date}
                  onChange={handleInputChange}
                />
                <input
                  type="email"
                  name="ownerEmail"
                  placeholder="Düğün Sahibinin E-postası"
                  value={newWeddingData.ownerEmail}
                  onChange={handleInputChange}
                  required
                />

                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Web Sitesi Teması
                </label>
                <select name="theme" value={newWeddingData.theme} onChange={handleInputChange}>
                  <option value="default">Pembe Tema</option>
                  <option value="classic-grey">Klasik Gri</option>
                  <option value="modern-blue">Modern Mavi</option>
                  <option value="lavender-dream">Lavanta Rüyası</option>
                  <option value="vibrant-mint">Nane Yeşili</option>
                </select>

                {/* ✅ GÜNCELLEME 4: ALBÜM YAPISI SEÇİMİ */}
                <label style={{ display: 'block', marginTop: '15px', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Paket / Albüm Yapısı
                </label>
                <select
                  name="albumMode"
                  value={newWeddingData.albumMode}
                  onChange={handleInputChange}
                  style={{ backgroundColor: '#f0f9ff', borderColor: '#bae6fd' }}
                >
                  <option value="default">Paket 1: Standart (Tek Akış)</option>
                  <option value="dual">Paket 2: Çift Albüm (Gelin & Damat)</option>
                  <option value="triple">Paket 3: Üçlü Albüm (Hazırlık, Nikah, Eğlence)</option>
                  <option value="demo">Demo Paket (2 GB, 3 Albüm)</option>
                </select>
                <small style={{ display: 'block', marginBottom: '15px', color: '#666', fontSize: '0.8rem' }}>
                  * Misafirler fotoğraf yüklerken bu albümleri görecektir.
                </small>

                <button className="btn" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Oluşturuluyor...' : 'Düğünü Oluştur'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Seçilen Düğünün Karekodunu Görüntüleme Modalı */}
      {viewingQrWedding && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ textAlign: 'center', maxWidth: '400px' }}>
            <button onClick={() => setViewingQrWedding(null)} className="modal-close-btn">
              &times;
            </button>
            <h3 style={{ marginBottom: '20px' }}>{viewingQrWedding.name}</h3>
            
            <div style={{ background: 'white', padding: '15px', display: 'inline-block', borderRadius: '10px' }}>
                <QRCodeSVG
                  value={`${window.location.origin}/w/${viewingQrWedding.code}`}
                  size={250}
                  level="H"
                  includeMargin={true}
                />
            </div>
            
            <div style={{ marginTop: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '5px', fontSize: '13px', wordBreak: 'break-all' }}>
              <strong>URL:</strong> {window.location.origin}/w/{viewingQrWedding.code}
            </div>
            
            <p style={{ fontSize: '11px', marginTop: '10px', color: '#666', fontStyle: 'italic' }}>
              Masaüstünde karekoda sağ tıklayıp "Resmi Farklı Kaydet" diyerek indirebilirsiniz. (Ayrıca cep telefonundan uzun basarak galeriye kaydedilebilir.)
            </p>
            
            <button className="btn" onClick={() => setViewingQrWedding(null)} style={{ marginTop: '20px' }}>
              Kapat
            </button>
          </div>
        </div>
      )}

      {/* Blog Ekleme Modalı */}
      {isBlogModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '800px' }}>
            <button onClick={() => setIsBlogModalOpen(false)} className="modal-close-btn">
              &times;
            </button>

            <form onSubmit={handleBlogSubmit}>
              <h2>Yeni Blog Yazısı Yaz</h2>

              <div className="input-group">
                <label>Yazı Başlığı</label>
                <input
                  type="text"
                  placeholder="Blog başlığını girin..."
                  value={newBlogData.title}
                  onChange={(e) => setNewBlogData({ ...newBlogData, title: e.target.value })}
                  required
                />
              </div>

              <div className="input-group">
                <label>Kapak Görseli URL</label>
                <input
                  type="text"
                  placeholder="https://..."
                  value={newBlogData.coverImage}
                  onChange={(e) => setNewBlogData({ ...newBlogData, coverImage: e.target.value })}
                />
              </div>

              <div className="input-group" style={{ marginBottom: '50px' }}>
                <label>İçerik</label>
                <ReactQuill
                  theme="snow"
                  value={newBlogData.content}
                  onChange={(val) => setNewBlogData({ ...newBlogData, content: val })}
                  style={{ height: '300px', backgroundColor: 'white' }}
                />
              </div>

              <button className="btn" type="submit" disabled={isSubmitting} style={{ marginTop: '20px' }}>
                {isSubmitting ? 'Yayınlanıyor...' : 'Yazıyı Yayınla'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Kupon Modalı */}
      {isCouponModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '800px', backgroundColor: '#f9fafb' }}>
            <button onClick={() => setIsCouponModalOpen(false)} className="modal-close-btn">
              &times;
            </button>
            <h2 style={{ marginBottom: '20px', color: '#1f2937' }}>İndirim Kuponları Yönetimi</h2>
            
            <form onSubmit={handleCouponSubmit} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', marginBottom: '30px', flexWrap: 'wrap', backgroundColor: 'white', padding: '15px', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
                <div style={{ flex: '1', minWidth: '150px' }}>
                    <label style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Kupon Kodu</label>
                    <input type="text" placeholder="ÖRNEK50" value={newCouponData.code} onChange={e => setNewCouponData({...newCouponData, code: e.target.value.toUpperCase()})} required style={{ width: '100%' }} />
                </div>
                <div style={{ flex: '1', minWidth: '120px' }}>
                    <label style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>İndirim Tipi</label>
                    <select value={newCouponData.discountType} onChange={e => setNewCouponData({...newCouponData, discountType: e.target.value})} style={{ width: '100%' }}>
                        <option value="percentage">Yüzdelik (%)</option>
                        <option value="fixed">Sabit Tutar (TL)</option>
                    </select>
                </div>
                <div style={{ flex: '1', minWidth: '100px' }}>
                    <label style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>İndirim Değeri</label>
                    <input type="number" min="1" placeholder="Oran/Tutar" value={newCouponData.discountValue} onChange={e => setNewCouponData({...newCouponData, discountValue: e.target.value})} required style={{ width: '100%' }} />
                </div>
                <div style={{ flex: '1', minWidth: '150px' }}>
                    <label style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Bitiş Tarihi (Opsiyonel)</label>
                    <input type="date" value={newCouponData.expirationDate} onChange={e => setNewCouponData({...newCouponData, expirationDate: e.target.value})} style={{ width: '100%' }} />
                </div>
                <button type="submit" className="btn" disabled={isSubmitting} style={{ whiteSpace: 'nowrap', alignSelf: 'flex-end' }}>
                    {isSubmitting ? '...' : '+ Ekle'}
                </button>
            </form>

            <div className="table-scroll">
              <table className="admin-table">
                <thead>
                    <tr>
                        <th>Kupon Kodu</th>
                        <th>İndirim</th>
                        <th>Kullanım</th>
                        <th>Bitiş Tarihi</th>
                        <th>Aktif mi?</th>
                        <th>İşlem</th>
                    </tr>
                </thead>
                <tbody>
                    {coupons.length === 0 ? (
                        <tr><td colSpan="6" style={{ textAlign: 'center' }}>Kupon bulunamadı.</td></tr>
                    ) : (
                        coupons.map(coupon => (
                            <tr key={coupon._id} style={{ backgroundColor: coupon.isActive ? 'white' : '#fef2f2' }}>
                                <td style={{ fontWeight: 'bold' }}>{coupon.code}</td>
                                <td>
                                    {coupon.discountType === 'percentage' 
                                        ? `%${coupon.discountValue}` 
                                        : `${coupon.discountValue} TL`}
                                </td>
                                <td>{coupon.usedCount} kez</td>
                                <td>{coupon.expirationDate ? new Date(coupon.expirationDate).toLocaleDateString() : 'Süresiz'}</td>
                                <td>
                                    <button 
                                        onClick={() => handleToggleCoupon(coupon._id)} 
                                        className={`btn-xs ${coupon.isActive ? 'btn-outline' : 'btn-danger'}`}
                                    >
                                        {coupon.isActive ? 'Aktif' : 'Pasif'}
                                    </button>
                                </td>
                                <td>
                                    <button onClick={() => handleDeleteCoupon(coupon._id, coupon.code)} className="btn-danger btn-xs">Sil</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      )}
      {/* LOG MODALI */}
      {isLogsModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '800px', width: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
            <button onClick={() => setIsLogsModalOpen(false)} className="modal-close-btn">&times;</button>
            <h2>📜 Sistem Logları ({logsWedding ? logsWedding.name : 'Genel'})</h2>
            
            {loadingLogs ? (
              <p>Loglar yükleniyor...</p>
            ) : weddingLogs.length === 0 ? (
              <p>Bu düğüne ait herhangi bir log bulunamadı.</p>
            ) : (
              <table className="admin-table" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>Seviye</th>
                    <th>İşlem</th>
                    <th>Mesaj</th>
                  </tr>
                </thead>
                <tbody>
                  {weddingLogs.map(l => (
                    <tr key={l._id} style={l.level === 'error' ? { backgroundColor: '#ffe5e5' } : l.level === 'warn' ? { backgroundColor: '#fffbe5' } : {}}>
                      <td>{new Date(l.createdAt).toLocaleString('tr-TR')}</td>
                      <td><strong>{l.level.toUpperCase()}</strong></td>
                      <td>{l.action}</td>
                      <td>
                        {l.message}
                        {l.metadata && Object.keys(l.metadata).length > 0 && (
                           <pre style={{ background: '#f4f4f4', padding: '5px', borderRadius: '4px', marginTop: '5px', overflowX: 'auto', fontSize: '0.75rem' }}>
                              {JSON.stringify(l.metadata, null, 2)}
                           </pre>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

    </div>
  );
}